import { useReadLocalStorage } from 'usehooks-ts'
import { Session, validateSession } from '@utils/sessions'

export default function useSession(): Session | null {
    const session = useReadLocalStorage<string>('session')

    if (!session) {
        return null
    }

    return validateSession(JSON.parse(session))
}
